const PHRASES = [
  "NO MONTHLY SAAS HOSTAGE BILLS",
  "COURT-TESTED WORK AUTHORIZATION",
  "INSTANT ZIP DELIVERY POST-CHECKOUT",
  "FIELD-PROVEN ON 1,400+ SERVICE BAYS",
  "READY-TO-PRINT PDF + EDITABLE EXCEL",
  "ZERO LOCKED SOFTWARE VENDOR CHAINS",
];

export default function Marquee() {
  const row = (
    <>
      {PHRASES.map((t, i) => (
        <span key={i} className="inline-flex items-center gap-6 pr-6">
          <span>{t}</span>
          <span className="w-1.5 h-1.5 bg-blaze rotate-45 inline-block" />
        </span>
      ))}
    </>
  );
  return (
    <div data-testid="marquee" className="relative overflow-hidden border-y border-slate-400/10 bg-raised py-3">
      <div className="animate-marquee whitespace-nowrap inline-flex font-mono text-[11px] uppercase tracking-[0.3em] text-slate-400">
        <div className="inline-flex">{row}{row}</div>
        <div className="inline-flex">{row}{row}</div>
      </div>
    </div>
  );
}
